import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const SkipMeetingOccurrenceMutation = graphql(`
  mutation SkipMeetingOccurrence($seriesId: ID!, $occurrenceDate: LocalDate!) {
    skipMeetingOccurrence(seriesId: $seriesId, occurrenceDate: $occurrenceDate) {
      id
      __typename
      scheduledDate
      scheduledStartTime
      scheduledEndTime
      occurrenceDate
      client {
        id
        legacyId
        name
        externalReference
        __typename
      }
    }
  }
`);

export function useSkipOccurrence() {
  const [result, skipOccurrenceMutation] = useMutation(SkipMeetingOccurrenceMutation);
  const [error, setError] = useState<Error | null>(null);

  const skipOccurrence = useCallback(
    async (seriesId: string, occurrenceDate: string) => {
      try {
        const response = await skipOccurrenceMutation({ seriesId, occurrenceDate });
        if (response.error) {
          throw response.error;
        }
        return response.data?.skipMeetingOccurrence;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [skipOccurrenceMutation],
  );

  return { skipOccurrence, result, error };
}
